class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      if (event.target && event.target.matches && event.target.matches('[data-upsell-select]')) return;
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    this.addEventListener('click', async (event) => {
      const target = event.target.closest('.cart-upsell-button, .cart-downgrade-button');
      if (!target) return;

      event.preventDefault();
      try {
        const planName = target.dataset.sellingPlanName || '';
        const isDowngrade = target.classList.contains('cart-downgrade-button');
        const eventName = isDowngrade ? 'downgrade_from_subscription' : 'upgrade_to_subscription';
        if (window.GAAnalytics && typeof window.GAAnalytics.pushEvent === 'function') {
          window.GAAnalytics.pushEvent(eventName, { subscription_plan: planName }, isDowngrade ? 'Cart drawer downgrade click' : 'Cart drawer upsell click');
        } else if (window.dataLayer && Array.isArray(window.dataLayer)) {
          window.dataLayer.push({ event: eventName, subscription_plan: planName });
        } else if (typeof window.gtag === 'function') {
          window.gtag('event', eventName, { subscription_plan: planName });
        }
      } catch (_) {}
      const line = parseInt(target.dataset.line, 10);
      const quantity = parseInt(target.dataset.quantity, 10) || 1;
      const variantId = parseInt(target.dataset.variantId, 10);
      const isDowngrade = target.classList.contains('cart-downgrade-button');
      const sellingPlanId = isDowngrade ? null : parseInt(target.dataset.sellingPlanId, 10);
      let properties = {};
      try {
        properties = JSON.parse(target.dataset.properties || '{}') || {};
      } catch (e) {
        properties = {};
      }
      if (isDowngrade) {
        await this.convertLineToOneTime({ line, quantity, variantId, properties });
      } else {
        await this.convertLineToSubscription({ line, quantity, variantId, sellingPlanId, properties });
      }
    });
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  async convertLineToSubscription({ line, quantity, variantId, sellingPlanId, properties = {} }) {
    try {
      this.enableLoading(line);

      const removeBody = JSON.stringify({
        line,
        quantity: 0,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });
      const removeRes = await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body: removeBody } });
      // fallback on remove error
      if (!removeRes.ok) {
        this.onCartUpdate();
      }

      // Add same variant back with selling_plan
      const addPayload = {
        id: variantId,
        quantity,
        selling_plan: sellingPlanId,
      };
      if (properties && Object.keys(properties).length > 0) {
        addPayload.properties = properties;
      }

      const addConfig = fetchConfig('javascript');
      addConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete addConfig.headers['Content-Type'];
      const formData = new FormData();
      formData.append('items[0][id]', String(addPayload.id));
      formData.append('items[0][quantity]', String(addPayload.quantity));
      formData.append('items[0][selling_plan]', String(addPayload.selling_plan));
      if (addPayload.properties) {
        Object.keys(addPayload.properties).forEach((key) => {
          formData.append(`items[0][properties][${key}]`, String(addPayload.properties[key]));
        });
      }
      // sections for drawer
      const drawerEl = document.querySelector('cart-drawer');
      const sectionsForAdd = drawerEl && drawerEl.getSectionsToRender ? drawerEl.getSectionsToRender() : this.getSectionsToRender();
      sectionsForAdd.forEach((section) => formData.append('sections', section.id || section.section));
      formData.append('sections_url', window.location.pathname);
      addConfig.body = formData;

      const response = await fetch(`${routes.cart_add_url}`, addConfig);
      let parsed = null;
      try { parsed = await response.json(); } catch (e) { parsed = null; }
      if (!response.ok) {
        // fallback
        this.onCartUpdate();
        return;
      }
      // re-render drawer
      const cartDrawerWrapper = document.querySelector('cart-drawer');
      const ensureRenderFromSections = async (sectionsMap) => {
        if (!sectionsMap) {
          const ids = ['cart-drawer', 'cart-icon-bubble'];
          const url = `${window.location.pathname}?sections=${ids.join(',')}`;
          const fresh = await fetch(url).then((r) => r.json()).catch(() => null);
          if (fresh) {
            cartDrawerWrapper && cartDrawerWrapper.renderContents && cartDrawerWrapper.renderContents({ sections: fresh });
          } else {
            this.onCartUpdate();
          }
          return;
        }
        // Validate expected selector exists inside cart-drawer HTML before rendering
        try {
          const drawerHtml = sectionsMap['cart-drawer'];
          const hasDrawerRoot = drawerHtml
            && new DOMParser().parseFromString(drawerHtml, 'text/html').querySelector('#CartDrawer');
          if (!hasDrawerRoot) {
            // Fallback to fetching authoritative sections to avoid layout break
            return await ensureRenderFromSections(null);
          }
        } catch (_) {
          return await ensureRenderFromSections(null);
        }
        if (cartDrawerWrapper && typeof cartDrawerWrapper.renderContents === 'function') {
          cartDrawerWrapper.renderContents({ sections: sectionsMap });
        } else {
          this.onCartUpdate();
        }
      };

      if (parsed && parsed.sections) {
        await ensureRenderFromSections(parsed.sections);
      } else {
        await ensureRenderFromSections(null);
      }
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
    } catch (e) {
      console.error(e);
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      if (errors) errors.textContent = window.cartStrings.error;
    } finally {
      this.disableLoading(line);
    }
  }

  async convertLineToOneTime({ line, quantity, variantId, properties = {} }) {
    try {
      this.enableLoading(line);

      const removeBody = JSON.stringify({
        line,
        quantity: 0,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });
      const removeRes = await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body: removeBody } });
      if (!removeRes.ok) {
        this.onCartUpdate();
      }

      const addConfig = fetchConfig('javascript');
      addConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete addConfig.headers['Content-Type'];
      const formData = new FormData();
      formData.append('items[0][id]', String(variantId));
      formData.append('items[0][quantity]', String(quantity));
      if (properties && Object.keys(properties).length > 0) {
        Object.keys(properties).forEach((key) => {
          formData.append(`items[0][properties][${key}]`, String(properties[key]));
        });
      }
      const drawerEl = document.querySelector('cart-drawer');
      const sectionsForAdd = drawerEl && drawerEl.getSectionsToRender ? drawerEl.getSectionsToRender() : this.getSectionsToRender();
      sectionsForAdd.forEach((section) => formData.append('sections', section.id || section.section));
      formData.append('sections_url', window.location.pathname);
      addConfig.body = formData;

      const response = await fetch(`${routes.cart_add_url}`, addConfig);
      let parsed = null;
      try { parsed = await response.json(); } catch (e) { parsed = null; }
      if (!response.ok) {
        this.onCartUpdate();
        return;
      }
      const cartDrawerWrapper = document.querySelector('cart-drawer');
      const ensureRenderFromSections = async (sectionsMap) => {
        if (!sectionsMap) {
          const ids = ['cart-drawer', 'cart-icon-bubble'];
          const url = `${window.location.pathname}?sections=${ids.join(',')}`;
          const fresh = await fetch(url).then((r) => r.json()).catch(() => null);
          if (fresh) {
            cartDrawerWrapper && cartDrawerWrapper.renderContents && cartDrawerWrapper.renderContents({ sections: fresh });
          } else {
            this.onCartUpdate();
          }
          return;
        }
        try {
          const drawerHtml = sectionsMap['cart-drawer'];
          const hasDrawerRoot = drawerHtml
            && new DOMParser().parseFromString(drawerHtml, 'text/html').querySelector('#CartDrawer');
          if (!hasDrawerRoot) {
            return await ensureRenderFromSections(null);
          }
        } catch (_) {
          return await ensureRenderFromSections(null);
        }
        if (cartDrawerWrapper && typeof cartDrawerWrapper.renderContents === 'function') {
          cartDrawerWrapper.renderContents({ sections: sectionsMap });
        } else {
          this.onCartUpdate();
        }
      };

      if (parsed && parsed.sections) {
        await ensureRenderFromSections(parsed.sections);
      } else {
        await ensureRenderFromSections(null);
      }
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
    } catch (e) {
      console.error(e);
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      if (errors) errors.textContent = window.cartStrings.error;
    } finally {
      this.disableLoading(line);
    }
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
